/**
 * 安全配置
 */

export const SECURITY_CONFIG = {
  // 不活跃超时时间（分钟）
  INACTIVITY_TIMEOUT_MINUTES: 10,
  
  // 是否启用不活跃超时
  ENABLE_INACTIVITY_TIMEOUT: true,
  
  // Session 配置建议（在 Clerk Dashboard 中设置）
  RECOMMENDED_SESSION_LIFETIME_HOURS: 8,
  
  // 敏感操作的超时时间（分钟）
  SENSITIVE_OPERATION_TIMEOUT_MINUTES: 5,
};

/**
 * 根据角色获取超时时间
 * 不同角色可以有不同的超时设置
 */
export const getInactivityTimeoutByRole = (role?: string): number => {
  switch (role) {
    case 'admin':
      // 管理员：较短的超时时间（更安全）
      return 15;
    
    case 'qa':
      // QA：中等超时时间
      return 30;
    
    case 'dev':
    case 'reviewer':
      // 开发/审查：较长的超时时间（查看报告可能需要更长时间）
      return 60;
    
    default:
      // 默认：使用全局配置
      return SECURITY_CONFIG.INACTIVITY_TIMEOUT_MINUTES;
  }
};

/**
 * 环境变量覆盖（可选）
 */
export const getInactivityTimeout = (): number => {
  const envTimeout = process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES;
  if (envTimeout) {
    const timeout = parseInt(envTimeout, 10);
    if (!isNaN(timeout) && timeout > 0) {
      return timeout;
    }
  }
  return SECURITY_CONFIG.INACTIVITY_TIMEOUT_MINUTES;
};

